
export default {
	name: 'am-annotation',
	props: {
		label: {type: String, default: 'Annotation'}
	},
}
